(function() {
    'use strict';

a3_cabin_reports.directive('turnAroundTimes',turnAroundTimes);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name turnAroundTimes
   * @restrict EA
   * @description
   *   Implementation of turnAroundTimes
   *
   *   Initialize the turn Around Times panel needs to have flight in scope
   * @example
   *   Usage:
   *   <div turn-around-times></div>
   * @ngInject
   */    
function turnAroundTimes(AircaftPositionsFactory,turnArroundTimesAcTypes) {
    
    /**
     * Initialize turnAroundTimes
     * @memberof turnAroundTimes
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link ($scope, element, attrs) {
        $scope.showTaTpanel = false;
        
        var supportsTurnArroundTimes = $scope.flight && turnArroundTimesAcTypes.includes($scope.flight.AcType);

        if($scope.flight && $scope.flight.FlightId && $scope.flight.ATD && supportsTurnArroundTimes){
            var aircaftPositions =  AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
            if(aircaftPositions != null && aircaftPositions.PreviousATA){
               /* var scheduledGroundTime = Date.DifferenceInMinutes(aircaftPositions.PreviousSTA, $scope.flight.ScheduledDeparture);
                var actualGroundTime = Date.DifferenceInMinutes(aircaftPositions.PreviousATA, $scope.flight.ScheduledDeparture);
               */ 
                var std = moment.utc($scope.flight.ScheduledDeparture);
                var atd = moment.utc($scope.flight.ATD);
                var startofTAT = moment.utc($scope.flight.ScheduledDeparture).add(-45, 'm');
                var prevATA = moment.utc(aircaftPositions.PreviousATA);
                
                var lateArrival = prevATA.diff(startofTAT, 'm');
                var scheduledTurnAroundTime = std.diff(startofTAT,'m');
                
                var comparedValue = startofTAT;
                if(lateArrival > 0){
                    var comparedValue = prevATA;
                }
                var actualTurnAroundTime = atd.diff(comparedValue,'m');
               
                $scope.scheduledTurnAroundTime = scheduledTurnAroundTime;
                $scope.actualTurnAroundTime = actualTurnAroundTime;
                $scope.lateArrival = lateArrival;
                $scope.showTaTpanel = true;
            }
        }

    }
    return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/turnAroundTimes.tpl.html',
			scope : false,
            link: link 
    }
}

})();